import { createFileRoute } from '@tanstack/react-router'

import { AdminPayoutsPage } from '@/pages/admin/payouts/admin-payouts-page'

export const Route = createFileRoute('/_private/admin/payouts')({
  component: AdminPayoutsPage,
})
